export function requireElement<T extends Element>(
  selector: string,
  parent: ParentNode = document,
): T {
  const element = parent.querySelector<T>(selector);
  if (element === null) {
    throw new Error(`Required UI element is missing: ${selector}`);
  }
  return element;
}

export function clearElement(element: Element): void {
  element.replaceChildren();
}

export function createElement<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  className?: string,
  text?: string,
): HTMLElementTagNameMap[K] {
  const element = document.createElement(tag);
  if (className !== undefined) {
    element.className = className;
  }
  if (text !== undefined) {
    element.textContent = text;
  }
  return element;
}

export function prettyJson(value: unknown): string {
  return JSON.stringify(value, null, 2);
}

